import {
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
  Tooltip,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Legend,
  Text,
} from "recharts";
import ActionButton1 from "../utils/ActionButton1";
import { Link } from "react-router-dom";
import React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import LandingSection from "../components/LandingSection";
import Footer from "../components/Footer";

import {
  hillAfbAtGlance,
  workforceBreakdown,
  expenditureBreakdown,
  economicImpactBreakdown,
} from "./data/hillAfbData";
import {
  LocationOn as LocationIcon,
  Phone as PhoneIcon,
  Language as WebsiteIcon,
} from "@mui/icons-material";
import SocialMediaEmbed from "./SocialMediaEmbed";
const airforce = "/img/af-logo-seal.webp";
const max = "/img/max.webp";
const a = "/img/75th Air Base Wing (75 ABW).webp";
const b = "/img/Ogden Air Logistics Complex (OO-ALC).webp";
const c = "/img/748th Supply Chain Management Group (748 SCMG).webp";
const d =
  "/img/Automatic Test Systems Directorate (of Air Force Life Cycle Management Center).webp";
const e = "/img/Munitions Division (of Armament Directorate, AFLCMC).webp";
const f =
  "/img/Aerospace Enabler Division (of Battle Management Directorate, AFLCMC).webp";
const g =
  "/img/Air Force Advance Composites Office (of Engineering Directorate, AFLCMC).webp";
const h =
  "/img/F-35 Program Office Operating Location (of F-35 Joint Program Office).webp";
const i = "/img/A-10 Division (of Fighter-Bomber Directorate, AFLCMC).webp";
const j = "/img/F-16 Division (of Fighter-Bomber Directorate, AFLCMC).webp";
const k = "/img/F-22 Division (of Fighter-Bomber Directorate, AFLCMC).webp";
const l =
  "/img/Product Data Services Division (of Logistics Directorate, AFLCMC).webp";
const m =
  "/img/Ground-Based Strategic Deterrent Systems Directorate (of Air Force Nuclear Weapons Center).webp";
const n = "/img/Minuteman III Systems Directorate (of AFNWC).webp";
const o = "/img/388th Fighter Wing (F-35).webp";
const p = "/img/419th Fighter Wing (AF Reserve Associate to 388 FW).webp";
const q = "/img/729th Air Control Squadron.webp";
const r = "/img/Defense Logistics Agency- Hill AFB, UT (DDHU).webp";
const s = "/img/Defense Information Systems Agency (DISA).webp";
const t = "/img/Utah Test and Training Range (UTTR).webp";
const u =
  "/img/Hill Aerospace Museum (Aerospace Heritage Foundation of Utah).webp";
const v = "/img/Defense Commissary Agency (DeCA).webp";
const w = "/img/Army and Air Force Exchange Service (AAFES).webp";
const x2 = "/img/Air Force Aid Society.webp";
const y = "/img/American Red Cross.jpeg";
const z = "/img/Air Force Recruiting Service.webp";
const z1 = "/img/United States Postal Service.png";
const z2 = "/img/United States Army Corps of Engineers (USACE).webp";
const museum = "/img/museum.png";
const x = "/img/x.png";
const instagram = "/img/instagram.png";
const facebook = "/img/facebook.png";

const CustomAxisTick = ({ x, y, payload }) => {
  return (
    <Text
      x={x}
      y={y}
      dy={16}
      width={75}
      textAnchor="middle"
      verticalAnchor="start"
      fill="#374151"
      fontSize={10}
      fontWeight={500}
    >
      {payload.value}
    </Text>
  );
};

const socialMediaPosts = [
  {
    platform: "Twitter (X)",
    link: "https://x.com/hafb",
    embed: `<blockquote class="twitter-tweet"><p lang="en" dir="ltr">Head&#39;s up today! The F-35 Demo Team and 388th Fighter Wing will be flying over Utah today between 1 and 3 p.m. Here&#39;s a link to the route and the approximate times: <a href="https://t.co/EgZQD7vd6D">https://t.co/EgZQD7vd6D</a> <a href="https://t.co/0ofhUGRtPS">pic.twitter.com/0ofhUGRtPS</a></p>&mdash; Hill Air Force Base (@HAFB) <a href="https://twitter.com/HAFB/status/1255905483807952896?ref_src=twsrc%5Etfw">April 30, 2020</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>`,
    icon: x,
  },
  {
    platform: "Instagram",
    link: "https://www.instagram.com/officialhillafb/#",
    embed: `<blockquote class="instagram-media" data-instgrm-captioned data-instgrm-permalink="https://www.instagram.com/p/DE3L0hZT7k8/?utm_source=ig_embed&amp;utm_campaign=loading" data-instgrm-version="14" style=" background:#FFF; border:0; border-radius:3px; box-shadow:0 0 1px 0 rgba(0,0,0,0.5),0 1px 10px 0 rgba(0,0,0,0.15); margin: 1px; max-width:540px; min-width:326px; padding:0; width:99.375%; width:-webkit-calc(100% - 2px); width:calc(100% - 2px);"><div style="padding:16px;"> <a href="https://www.instagram.com/p/DE3L0hZT7k8/?utm_source=ig_embed&amp;utm_campaign=loading" style=" background:#FFFFFF; line-height:0; padding:0 0; text-align:center; text-decoration:none; width:100%;" target="_blank"> <div style=" display: flex; flex-direction: row; align-items: center;"> <div style="background-color: #F4F4F4; border-radius: 50%; flex-grow: 0; height: 40px; margin-right: 14px; width: 40px;"></div> <div style="display: flex; flex-direction: column; flex-grow: 1; justify-content: center;"> <div style=" background-color: #F4F4F4; border-radius: 4px; flex-grow: 0; height: 14px; margin-bottom: 6px; width: 100px;"></div> <div style=" background-color: #F4F4F4; border-radius: 4px; flex-grow: 0; height: 14px; width: 60px;"></div></div></div><div style="padding: 19% 0;"></div> <div style="display:block; height:50px; margin:0 auto 12px; width:50px;"><svg width="50px" height="50px" viewBox="0 0 60 60" version="1.1" xmlns="https://www.w3.org/2000/svg" xmlns:xlink="https://www.w3.org/1999/xlink"><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-511.000000, -20.000000)" fill="#000000"><g><path d="M556.869,30.41 C554.814,30.41 553.148,32.076 553.148,34.131 C553.148,36.186 554.814,37.852 556.869,37.852 C558.924,37.852 560.59,36.186 560.59,34.131 C560.59,32.076 558.924,30.41 556.869,30.41 M541,60.657 C535.114,60.657 530.342,55.887 530.342,50 C530.342,44.114 535.114,39.342 541,39.342 C546.887,39.342 551.658,44.114 551.658,50 C551.658,55.887 546.887,60.657 541,60.657 M541,33.886 C532.1,33.886 524.886,41.1 524.886,50 C524.886,58.899 532.1,66.113 541,66.113 C549.9,66.113 557.115,58.899 557.115,50 C557.115,41.1 549.9,33.886 541,33.886 M565.378,62.101 C565.244,65.022 564.756,66.606 564.346,67.663 C563.803,69.06 563.154,70.057 562.106,71.106 C561.058,72.155 560.06,72.803 558.662,73.347 C557.607,73.757 556.021,74.244 553.102,74.378 C549.944,74.521 548.997,74.552 541,74.552 C533.003,74.552 532.056,74.521 528.898,74.378 C525.979,74.244 524.393,73.757 523.338,73.347 C521.94,72.803 520.942,72.155 519.894,71.106 C518.846,70.057 518.197,69.06 517.654,67.663 C517.244,66.606 516.755,65.022 516.623,62.101 C516.479,58.943 516.448,57.996 516.448,50 C516.448,42.003 516.479,41.056 516.623,37.899 C516.755,34.978 517.244,33.391 517.654,32.338 C518.197,30.938 518.846,29.942 519.894,28.894 C520.942,27.846 521.94,27.196 523.338,26.654 C524.393,26.244 525.979,25.756 528.898,25.623 C532.057,25.479 533.004,25.448 541,25.448 C548.997,25.448 549.943,25.479 553.102,25.623 C556.021,25.756 557.607,26.244 558.662,26.654 C560.06,27.196 561.058,27.846 562.106,28.894 C563.154,29.942 563.803,30.938 564.346,32.338 C564.756,33.391 565.244,34.978 565.378,37.899 C565.522,41.056 565.552,42.003 565.552,50 C565.552,57.996 565.522,58.943 565.378,62.101 M570.82,37.631 C570.674,34.438 570.167,32.258 569.425,30.349 C568.659,28.377 567.633,26.702 565.965,25.035 C564.297,23.368 562.623,22.342 560.652,21.575 C558.743,20.834 556.562,20.326 553.369,20.18 C550.169,20.033 549.148,20 541,20 C532.853,20 531.831,20.033 528.631,20.18 C525.438,20.326 523.257,20.834 521.349,21.575 C519.376,22.342 517.703,23.368 516.035,25.035 C514.368,26.702 513.342,28.377 512.574,30.349 C511.834,32.258 511.326,34.438 511.181,37.631 C511.035,40.831 511,41.851 511,50 C511,58.147 511.035,59.17 511.181,62.369 C511.326,65.562 511.834,67.743 512.574,69.651 C513.342,71.625 514.368,73.296 516.035,74.965 C517.703,76.634 519.376,77.658 521.349,78.425 C523.257,79.167 525.438,79.673 528.631,79.82 C531.831,79.965 532.853,80.001 541,80.001 C549.148,80.001 550.169,79.965 553.369,79.82 C556.562,79.673 558.743,79.167 560.652,78.425 C562.623,77.658 564.297,76.634 565.965,74.965 C567.633,73.296 568.659,71.625 569.425,69.651 C570.167,67.743 570.674,65.562 570.82,62.369 C570.966,59.17 571,58.147 571,50 C571,41.851 570.966,40.831 570.82,37.631"></path></g></g></g></svg></div><div style="padding-top: 8px;"> <div style=" color:#3897f0; font-family:Arial,sans-serif; font-size:14px; font-style:normal; font-weight:550; line-height:18px;">View this post on Instagram</div></div><div style="padding: 12.5% 0;"></div> <div style="display: flex; flex-direction: row; margin-bottom: 14px; align-items: center;"><div> <div style="background-color: #F4F4F4; border-radius: 50%; height: 12.5px; width: 12.5px; transform: translateX(0px) translateY(7px);"></div> <div style="background-color: #F4F4F4; height: 12.5px; transform: rotate(-45deg) translateX(3px) translateY(1px); width: 12.5px; flex-grow: 0; margin-right: 14px; margin-left: 2px;"></div> <div style="background-color: #F4F4F4; border-radius: 50%; height: 12.5px; width: 12.5px; transform: translateX(9px) translateY(-18px);"></div></div><div style="margin-left: 8px;"> <div style=" background-color: #F4F4F4; border-radius: 50%; flex-grow: 0; height: 20px; width: 20px;"></div> <div style=" width: 0; height: 0; border-top: 2px solid transparent; border-left: 6px solid #f4f4f4; border-bottom: 2px solid transparent; transform: translateX(16px) translateY(-4px) rotate(30deg)"></div></div><div style="margin-left: auto;"> <div style=" width: 0px; border-top: 8px solid #F4F4F4; border-right: 8px solid transparent; transform: translateY(16px);"></div> <div style=" background-color: #F4F4F4; flex-grow: 0; height: 12px; width: 16px; transform: translateY(-4px);"></div> <div style=" width: 0; height: 0; border-top: 8px solid #F4F4F4; border-left: 8px solid transparent; transform: translateY(-4px) translateX(8px);"></div></div></div> <div style="display: flex; flex-direction: column; flex-grow: 1; justify-content: center; margin-bottom: 24px;"> <div style=" background-color: #F4F4F4; border-radius: 4px; flex-grow: 0; height: 14px; margin-bottom: 6px; width: 224px;"></div> <div style=" background-color: #F4F4F4; border-radius: 4px; flex-grow: 0; height: 14px; width: 144px;"></div></div></a><p style=" color:#c9c8cd; font-family:Arial,sans-serif; font-size:14px; line-height:17px; margin-bottom:0; margin-top:8px; overflow:hidden; padding:8px 0 7px; text-align:center; text-overflow:ellipsis; white-space:nowrap;"><a href="https://www.instagram.com/p/DE3L0hZT7k8/?utm_source=ig_embed&amp;utm_campaign=loading" style=" color:#c9c8cd; font-family:Arial,sans-serif; font-size:14px; font-style:normal; font-weight:normal; line-height:17px; text-decoration:none;" target="_blank">A post shared by Hill Air Force Base (@officialhillafb)</a></p></div></blockquote><script async src="//www.instagram.com/embed.js"></script>`,
    icon: instagram,
  },
  {
    platform: "Facebook",
    link: "https://www.facebook.com/HillAirForceBase/",
    embed: `<iframe src="https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Fpermalink.php%3Fstory_fbid%3D473233515823129%26id%3D100094094523055&show_text=true&width=500" width="500" height="737" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>`,
    icon: facebook,
  },
];



{/* <BarChart data={workforceBreakdown}>
  <XAxis dataKey="name" tick={{ fontSize: 11 }} />
  <YAxis />
  <Tooltip formatter={(v) => `${v.toLocaleString()} Jobs`} />
  <Bar dataKey="value" fill="#374151" radius={[6, 6, 0, 0]} />
</BarChart>
<PieChart>
  <Pie
    data={expenditureBreakdown}
    dataKey="value"
    nameKey="name"
    outerRadius={95}
  />
  <Tooltip formatter={(v) => `$${v} Million USD`} />
</PieChart>
<PieChart>
  <Pie
    data={economicImpactBreakdown}
    dataKey="value"
    nameKey="name"
    innerRadius={60}
    outerRadius={95}
  />
  <Tooltip formatter={(v) => `$${v} Billion USD`} />
</PieChart> */}

const Airforce = () => {
  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-b from-blue-50 to-white">
      {/* Landing Section */}
      <LandingSection
        data={{
          imageName: "f-16.avif",
          title: "Utah is proud to host Hill AFB",
          visible: "",
        }}
      />

      <div className="flex-grow mx-auto py-12 w-full">
        {/* Hill Airforce */}
        <div className="px-4 sm:px-6 lg:px-8 mb-12 max-w-7xl mx-auto">
          <div className="flex justify-center items-center gap-4">
            <img
              src={airforce}
              alt="Hill AFB jet, Utah"
              className="h-[5rem] w-[5rem]"
            />
            <h1 className="underline text-2xl sm:text-4xl md:text-5xl font-bold mb-4 text-center text-blue-900">
              Hill Air Force Base
            </h1>
          </div>
          {/* <p className="text-gray-800 text-2xl text-center"></p> */}
          <p className="text-gray-800 sm:text-xl text-center">
            Hill Air Force Base (HAFB) is a major United States Air Force base
            located in Davis County, Utah, approximately 30 miles north of Salt
            Lake City and 8 miles south of Ogden
          </p>
          <p className="text-gray-800 sm:text-xl text-center">
            Hill AFB is the largest single site employer in Utah, with more than
            22,000 military and civilian employees.
          </p>
          <div className="flex flex-col justify-center items-center">
            <img
              src={max}
              alt="Brigadier General Max J. Stitzer, USAF (Retired)"
              className="h-[20rem] w-[20rem] mx-auto"
            />
            <a
              href="https://maxstitzer.org/"
              target="_blank"
              rel="noopener noreferrer"
              className="no-underline block text-center"
            >
              <div>Brigadier General Max J. Stitzer, USAF (Retired)</div>
            </a>
          </div>

          <p className="text-gray-800 text-sm sm:text-lg text-center my-[1rem]">
            UTahData is honored and privileged to have received support and
            guidance on the content of this page from Brigadier General Max J.
            Stitzer, USAF (Retired)
          </p>
        </div>
        <div className=" py-12 px-4 sm:px-6 lg:px-8">
          {/* <section className="max-w-7xl mx-auto bg-white text-centerrounded-2xl shadow-md p-8">
            <h2 className="text-2xl font-bold text-blue-900 mb-2">
              Hill Air Force Base — At a Glance [Year 2024]
            </h2>
            <p className="text-base text-gray-500 mb-8 max-w-2xl">
              Hill Air Force Base is an economic powerhouse for Utah. This dashboard highlights the base's economic footprint, workforce contribution, and critical role in national defense and the local economy.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-6">
              {hillAfbAtGlance.map((item, index) => (
                <div
                  key={index}
                  className="border border-gray-100 bg-white rounded-xl p-6 text-center hover:shadow-lg hover:-translate-y-1 transition-all duration-300"
                >
                  <div className="text-3xl font-extrabold text-red-700 mb-2">
                    {item.value}
                  </div>
                  <div className="text-sm font-semibold text-gray-800 uppercase tracking-wide mb-1">
                    {item.label}
                  </div>
                  <div className="text-xs text-gray-500 font-medium">
                    {item.subtext}
                  </div>
                </div>
              ))}
            </div>
          </section> */}
           <div className="flex justify-center items-center px-4">
                      <Link
                           to="/verticals/hill-airforce-base-economic-impact"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="block w-full max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg mx-auto text-center"
                      >
                        <div className="w-full">
                          <ActionButton1 data={"Hill Air Force Base Economic Impact"} />
                        </div>
                      </Link>
                    </div>
          {/* <section className="bg-white rounded-2xl p-6 space-y-10">

            <h2 className="text-3xl text-center font-semibold text-blue-900">
              Hill Air Force Base — Economic Impact Year 2024
            </h2>

          
            <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-4">
              {hillAfbAtGlance.map((item, i) => (
                <KpiCard key={i} {...item} />
              ))}
            </div>

        
            <div className="grid md:grid-cols-3 gap-8">

              <div className="bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-shadow duration-300 border border-gray-100 flex flex-col items-center">
                <h3 className="font-bold text-gray-800 mb-4 text-center">
                  Economic Impact Composition <br />
                  <span className="text-sm font-normal text-gray-500">(Billion USD)</span>
                </h3>
                <div className="w-full">
                  <EconomicImpactChart data={economicImpactBreakdown} />
                </div>
              </div>

              <div className="bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-shadow duration-300 border border-gray-100 flex flex-col items-center">
                <h3 className="font-bold text-gray-800 mb-4 text-center">
                  Annual Expenditures <br />
                  <span className="text-sm font-normal text-gray-500">(Million USD)</span>
                </h3>
                <div className="w-full">
                  <ExpenditureChart data={expenditureBreakdown} />
                </div>
              </div>

              <div className="bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-shadow duration-300 border border-gray-100 flex flex-col items-center">
                <h3 className="font-bold text-gray-800 mb-4 text-center">
                  Workforce Composition <br />
                  <span className="text-sm font-normal text-gray-500">(Jobs)</span>
                </h3>
                <div className="w-full">
                  <WorkforceChart data={workforceBreakdown} />
                </div>
              </div>

            </div>


            <div className="mt-8 text-center pt-4 border-t border-gray-100">
              <p className="text-sm text-gray-700 italic mb-4 px-4 max-w-3xl mx-auto">
                <span className="font-semibold">Note:</span> Total Economic Impact (TEI) figures for Hill AFB represent the combined value of annual federal payroll, expenditures, and the estimated value of jobs created within the local community.
              </p>
              <p className="text-sm text-gray-500 mb-2">Data Source:</p>
              <a
                href="https://nuea.org/2025/03/27/hill-air-force-base-generates-12-76-billion-in-economic-impact-in-2024/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm text-blue-600 hover:text-blue-800 underline hover:no-underline transition-all"
              >
                NUEA - Hill Air Force Base Generates $12.76 Billion in Economic Impact in 2024
              </a>
            </div>
          </section> */}
        </div>
        {/* Key Units */}
        <div className="px-4 sm:px-6 lg:px-8 mb-12 max-w-[95%] mx-auto">
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4 text-center text-blue-900 underline">
            Key Units and Operations
          </h1>
          <div>
            <Accordion
              expanded={true}
              sx={{
                cursor: "pointer",
                borderLeft: "8px solid blue", // left border (blue)
                transition: "transform 0.3s ease", // smooth zoom animation
                "&:hover": {
                  transform: "scale(1.01)", // zoom effect
                  boxShadow: "0 6px 20px rgba(0,0,0,0.15)", // optional shadow on hover
                },
                background: "#fafafa",
              }}
            >
              <AccordionSummary
                // expandIcon={<ArrowDownwardIcon />}
                aria-controls="panel1-content"
                id="panel1-header"
                className="transition"
              >
                <Typography component="span">
                  <span className="font-bold text-xl">
                    <i>Ogden Air Logistics Complex (OO-ALC)</i>
                  </span>
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  This is the heart of HAFB, responsible for the depot-level
                  maintenance of a wide range of aircraft, including F-16, F-22,
                  F-35, A-10, and C-130.3 It also maintains engines, missiles,
                  and other vital equipment.
                </Typography>
              </AccordionDetails>
            </Accordion>
            <Accordion
              expanded={true}
              sx={{
                cursor: "pointer",
                borderLeft: "8px solid green", // left border (blue)
                transition: "transform 0.3s ease", // smooth zoom animation
                "&:hover": {
                  transform: "scale(1.01)", // zoom effect
                  boxShadow: "0 6px 20px rgba(0,0,0,0.15)", // optional shadow on hover
                },
                background: "#fafafa",
              }}
            >
              <AccordionSummary
                // expandIcon={<ArrowDownwardIcon />}
                aria-controls="panel1-content"
                id="panel1-header"
                className="transition"
              >
                <Typography component="span">
                  <span className="font-bold text-xl">
                    <i>Flying Units: HAFB is home to two fighter wings</i>
                  </span>
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  388th Fighter Wing: An active-duty unit operating the F-35A
                  Lightning II stealth fighter.
                  <br />
                  419th Fighter Wing: An Air Force Reserve Command unit also
                  flying the F-35A.
                </Typography>
              </AccordionDetails>
            </Accordion>
            <Accordion
              expanded={true}
              sx={{
                cursor: "pointer",
                borderLeft: "8px solid pink", // left border (blue)
                transition: "transform 0.3s ease", // smooth zoom animation
                "&:hover": {
                  transform: "scale(1.01)", // zoom effect
                  boxShadow: "0 6px 20px rgba(0,0,0,0.15)", // optional shadow on hover
                },
                background: "#fafafa",
              }}
            >
              <AccordionSummary
                // expandIcon={<ArrowDownwardIcon />}
                aria-controls="panel1-content"
                id="panel1-header"
                className="transition"
              >
                <Typography component="span">
                  <span className="font-bold text-xl">
                    <i>75th Air Base Wing (75 ABW)</i>
                  </span>
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  Serves as the host unit, offering base operating support for
                  all units at Hill AFB, including the OO-ALC, the 388th and
                  419th Fighter Wings, and over 50 mission partner units.
                </Typography>
              </AccordionDetails>
            </Accordion>

            <Accordion
              expanded={true}
              sx={{
                cursor: "pointer",
                borderLeft: "8px solid orange", // left border (blue)
                transition: "transform 0.3s ease", // smooth zoom animation
                "&:hover": {
                  transform: "scale(1.01)", // zoom effect
                  boxShadow: "0 6px 20px rgba(0,0,0,0.15)", // optional shadow on hover
                },
                background: "#fafafa",
              }}
            >
              <AccordionSummary
                // expandIcon={<ArrowDownwardIcon />}
                aria-controls="panel1-content"
                id="panel1-header"
                className="transition"
              >
                <Typography component="span">
                  <span className="font-bold text-xl">
                    <i>
                      309-SWEG: A group of talented people, innovators,
                      engineers, computer scientists, IT, and cybersecurity
                      professionals.
                    </i>
                  </span>
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  They encompass hardware engineering, software engineering,
                  cybersecurity, cloud security, program management, consulting,
                  data management, and much more.
                </Typography>
              </AccordionDetails>
            </Accordion>
          </div>
        </div>

        {/* Mission Partner */}
        <div className="px-4 sm:px-6 lg:px-8 mb-12 max-w-[95%] mx-auto">
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4 text-center text-blue-900 underline">
            Hill AFB MISSION PARTNER ORGANISATIONS
          </h1>
          <div>
            <Accordion
              expanded={true}
              className="flex flex-col justify-center items-center"
            >
              <div className="font-bold text-3xl cursor-text m-8">
                <i>Hill Airforce Mission Partners</i>
              </div>

              <AccordionDetails className="">
                <div className="grid sm:grid-cols-2 mb-4 gap-10">
                  {/* First Column - 75th Air Base Wing */}
                  <div className="flex items-center gap-4">
                    <img src={a} alt="75 ABW Logo" className="w-10 h-10" />
                    <Typography className="!text-lg">
                      75th Air Base Wing (75 ABW) - Installation Host
                    </Typography>
                  </div>

                  {/* Second Column - Ogden Air Logistics Complex */}
                  <div className="flex items-center gap-4">
                    <img src={b} alt="OO-ALC Logo" className="w-10 h-10" />
                    <Typography className="!text-lg">
                      Ogden Air Logistics Complex (OO-ALC)
                    </Typography>
                  </div>
                </div>
                <div className="grid sm:grid-cols-2 mb-4 gap-10">
                  {/* First Column - 748 SCMG */}
                  <div className="flex items-center gap-4">
                    <img src={c} alt="748 SCMG Logo" className="w-10 h-10" />
                    <Typography className="!text-lg">
                      748th Supply Chain Management Group (748 SCMG)
                    </Typography>
                  </div>

                  {/* Second Column - Automatic Test Systems Directorate */}
                  <div className="flex items-center gap-4">
                    <img
                      src={d}
                      alt="ATS Directorate Logo"
                      className="w-10 h-10"
                    />
                    <Typography className="!text-lg">
                      Automatic Test Systems Directorate (of Air Force Life
                      Cycle Management Center)
                    </Typography>
                  </div>
                </div>

                <div className="grid sm:grid-cols-2 mb-4 gap-10">
                  {/* First Column - Munitions Division */}
                  <div className="flex items-center gap-4">
                    <img
                      src={e}
                      alt="Munitions Division Logo"
                      className="w-10 h-10"
                    />
                    <Typography className="!text-lg">
                      Munitions Division (of Armament Directorate, AFLCMC)
                    </Typography>
                  </div>

                  {/* Second Column - Aerospace Enabler Division */}
                  <div className="flex items-center gap-4">
                    <img
                      src={f}
                      alt="Aerospace Enabler Division Logo"
                      className="w-10 h-10"
                    />
                    <Typography className="!text-lg">
                      Aerospace Enabler Division (of Battle Management
                      Directorate, AFLCMC)
                    </Typography>
                  </div>
                </div>

                <div className="grid sm:grid-cols-2 mb-4 gap-10">
                  {/* First Column - Air Force Advance Composites Office */}
                  <div className="flex items-center gap-4">
                    <img
                      src={g}
                      alt="AF Advance Composites Office Logo"
                      className="w-10 h-10"
                    />
                    <Typography className="!text-lg">
                      Air Force Advance Composites Office (of Engineering
                      Directorate, AFLCMC)
                    </Typography>
                  </div>

                  {/* Second Column - F-35 Program Office */}
                  <div className="flex items-center gap-4">
                    <img
                      src={h}
                      alt="F-35 Program Office Logo"
                      className="w-10 h-10"
                    />
                    <Typography className="!text-lg">
                      F-35 Program Office Operating Location (of F-35 Joint
                      Program Office)
                    </Typography>
                  </div>
                </div>
                <div className="grid sm:grid-cols-2 mb-4 gap-10">
                  {/* First Column - A-10 Division */}
                  <div className="flex items-center gap-4">
                    <img
                      src={i}
                      alt="A-10 Division Logo"
                      className="w-10 h-10"
                    />
                    <Typography className="!text-lg">
                      A-10 Division (of Fighter-Bomber Directorate, AFLCMC)
                    </Typography>
                  </div>

                  {/* Second Column - F-16 Division */}
                  <div className="flex items-center gap-4">
                    <img
                      src={j}
                      alt="F-16 Division Logo"
                      className="w-10 h-10"
                    />
                    <Typography className="!text-lg">
                      F-16 Division (of Fighter-Bomber Directorate, AFLCMC)
                    </Typography>
                  </div>
                </div>

                <div className="grid sm:grid-cols-2 mb-4 gap-10">
                  {/* First Column - F-22 Division */}
                  <div className="flex items-center gap-4">
                    <img
                      src={k}
                      alt="F-22 Division Logo"
                      className="w-10 h-10"
                    />
                    <Typography className="!text-lg">
                      F-22 Division (of Fighter-Bomber Directorate, AFLCMC)
                    </Typography>
                  </div>

                  {/* Second Column - Product Data Services Division */}
                  <div className="flex items-center gap-4">
                    <img
                      src={l}
                      alt="Product Data Services Logo"
                      className="w-10 h-8"
                    />
                    <Typography className="!text-lg">
                      Product Data Services Division (of Logistics Directorate,
                      AFLCMC)
                    </Typography>
                  </div>
                </div>

                <div className="grid sm:grid-cols-2 mb-4 gap-10">
                  {/* First Column - Ground-Based Strategic Deterrent Systems Directorate */}
                  <div className="flex items-center gap-4">
                    <img
                      src={m}
                      alt="GBSD Systems Directorate Logo"
                      className="w-10 h-10"
                    />
                    <Typography className="!text-lg">
                      Ground-Based Strategic Deterrent Systems Directorate (of
                      Air Force Nuclear Weapons Center)
                    </Typography>
                  </div>

                  {/* Second Column - Minuteman III Systems Directorate */}
                  <div className="flex items-center gap-4">
                    <img
                      src={n}
                      alt="Minuteman III Systems Directorate Logo"
                      className="w-10 h-10"
                    />
                    <Typography className="!text-lg">
                      Minuteman III Systems Directorate (of AFNWC)
                    </Typography>
                  </div>
                </div>
                <div className="grid sm:grid-cols-2 mb-4 gap-10">
                  {/* 388th Fighter Wing */}
                  <div className="flex items-center gap-4">
                    <img
                      src={o}
                      alt="388th Fighter Wing Logo"
                      className="w-10 h-10"
                    />
                    <Typography className="!text-lg">
                      388th Fighter Wing (F-35)
                    </Typography>
                  </div>

                  {/* 419th Fighter Wing */}
                  <div className="flex items-center gap-4">
                    <img
                      src={p}
                      alt="419th Fighter Wing Logo"
                      className="w-10 h-10"
                    />
                    <Typography className="!text-lg">
                      419th Fighter Wing (AF Reserve Associate to 388 FW)
                    </Typography>
                  </div>
                </div>

                <div className="grid sm:grid-cols-2 mb-4 gap-10">
                  {/* 729th Air Control Squadron */}
                  <div className="flex items-center gap-4">
                    <img
                      src={q}
                      alt="729th Air Control Squadron Logo"
                      className="w-10 h-10"
                    />
                    <Typography className="!text-lg">
                      729th Air Control Squadron
                    </Typography>
                  </div>

                  {/* Defense Logistics Agency */}
                  <div className="flex items-center gap-4">
                    <img
                      src={r}
                      alt="Defense Logistics Agency Logo"
                      className="w-10 h-10"
                    />
                    <Typography className="!text-lg">
                      Defense Logistics Agency - Hill AFB, UT (DDHU)
                    </Typography>
                  </div>
                </div>

                <div className="grid sm:grid-cols-2 mb-4 gap-10">
                  {/* Defense Information Systems Agency */}
                  <div className="flex items-center gap-4">
                    <img src={s} alt="DISA Logo" className="w-10 h-10" />
                    <Typography className="!text-lg">
                      Defense Information Systems Agency (DISA)
                    </Typography>
                  </div>

                  {/* Utah Test and Training Range */}
                  <div className="flex items-center gap-4">
                    <img src={t} alt="UTTR Logo" className="w-10 h-10" />
                    <Typography className="!text-lg">
                      Utah Test and Training Range (UTTR)
                    </Typography>
                  </div>
                </div>

                <div className="grid sm:grid-cols-2 mb-4 gap-10">
                  {/* Hill Aerospace Museum */}
                  <div className="flex items-center gap-4">
                    <img
                      src={u}
                      alt="Hill Aerospace Museum Logo"
                      className="w-10 h-10"
                    />
                    <Typography className="!text-lg">
                      Hill Aerospace Museum (Aerospace Heritage Foundation of
                      Utah)
                    </Typography>
                  </div>

                  {/* Defense Commissary Agency */}
                  <div className="flex items-center gap-4">
                    <img src={v} alt="DeCA Logo" className="w-10 h-10" />
                    <Typography className="!text-lg">
                      Defense Commissary Agency (DeCA)
                    </Typography>
                  </div>
                </div>

                <div className="grid sm:grid-cols-2 mb-4 gap-10">
                  {/* Army and Air Force Exchange Service */}
                  <div className="flex items-center gap-4">
                    <img src={w} alt="AAFES Logo" className="w-10 h-10" />
                    <Typography className="!text-lg">
                      Army and Air Force Exchange Service (AAFES)
                    </Typography>
                  </div>

                  {/* Air Force Aid Society */}
                  <div className="flex items-center gap-4">
                    <img
                      src={x2}
                      alt="Air Force Aid Society Logo"
                      className="w-10 h-8"
                    />
                    <Typography className="!text-lg">
                      Air Force Aid Society
                    </Typography>
                  </div>
                </div>

                <div className="grid sm:grid-cols-2 mb-4 gap-10">
                  {/* American Red Cross */}
                  <div className="flex items-center gap-4">
                    <img src={y} alt="Red Cross Logo" className="w-10 h-4" />
                    <Typography className="!text-lg">
                      American Red Cross
                    </Typography>
                  </div>

                  {/* Air Force Recruiting Service */}
                  <div className="flex items-center gap-4">
                    <img
                      src={z}
                      alt="Air Force Recruiting Logo"
                      className="w-10 h-10"
                    />
                    <Typography className="!text-lg">
                      Air Force Recruiting Service
                    </Typography>
                  </div>
                </div>

                <div className="grid sm:grid-cols-2 mb-4 gap-10">
                  {/* United States Postal Service */}
                  <div className="flex items-center gap-4">
                    <img src={z1} alt="USPS Logo" className="w-10 h-10" />
                    <Typography className="!text-lg">
                      United States Postal Service
                    </Typography>
                  </div>

                  {/* United States Army Corps of Engineers */}
                  <div className="flex items-center gap-4">
                    <img src={z2} alt="USACE Logo" className="w-10 h-10" />
                    <Typography className="!text-lg">
                      United States Army Corps of Engineers (USACE)
                    </Typography>
                  </div>
                </div>
              </AccordionDetails>
            </Accordion>
          </div>
        </div>

        {/* Facilities and Attraction */}
        <div className="px-4 sm:px-6 lg:px-8 mb-12 max-w-7xl mx-auto">
          <h1 className="underline text-2xl sm:text-4xl md:text-5xl font-bold mb-4 text-center text-blue-900">
            Facilities and Attraction
          </h1>
          <p className="text-gray-800 sm:text-xl text-center">
            With over 70 aircraft on display, and thousands of historical Air
            Force artifacts,{" "}
            <a
              href="https://www.aerospaceutah.org/"
              className="no-underline"
              target="_blank"
              rel="noopener noreferrer"
            >
              {" "}
              Hill Aerospace Museum
            </a>{" "}
            offers an incredible opportunity for discovery and excitement for
            the whole family!
          </p>
          <p className="text-gray-800 sm:text-xl text-center">
            {" "}
            Founded in 1981, the museum is part of the United States Air Force
            Heritage Program and is supported by the Aerospace Heritage
            Foundation of Utah.
          </p>
          <p className="text-gray-800 sm:text-xl text-center">
            Whether it’s seeing the first aircraft ever manufactured, the
            lumbering B-17, the speed-demon SR-71 or the one-and-only F-117
            Stealth Fighter, Hill is a perfect location to unlock your inner
            child. With free admission for visitors, Hill Aerospace Museum is a
            great destination all year long.
          </p>
        </div>

        <div className="flex justify-center items-center mb-12">
          <a
            href="https://www.aerospaceutah.org/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={museum}
              alt="Aerospace Utah Museum"
              className="w-full max-w-[200px] sm:max-w-[200px] md:max-w-[300px] lg:max-w-[400px] xl:max-w-[500px] h-auto"
            />{" "}
          </a>
        </div>

        {/* Contact Section */}
        <div className="px-4 sm:px-6 lg:px-8 mb-12 max-w-[95%] mx-auto text-center">
          <div className="w-full py-[3vh] bg-gray-50 shadow-[0_4px_12px_0_rgba(1,76,178,0.3)] rounded-lg">
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-10 text-blue-900 underline">
              Contact Hill AFB
            </h1>

            <div className="flex flex-col-reverse lg:flex-row-reverse justify-center items-center gap-10 lg:gap-10 px-4">
              {/* Contact Info */}
              <div className="w-full lg:w-1/3 text-left space-y-6">
                <h3 className="flex items-start sm:items-center text-lg sm:text-2xl gap-3">
                  <LocationIcon className="text-blue-700" />
                  <span>7981 Georgia Street, Ogden, UT 84056</span>
                </h3>
                <h3 className="flex items-start sm:items-center text-lg sm:text-2xl gap-3">
                  <PhoneIcon className="text-blue-700" />
                  <span>+1(801) 777-1110</span>
                </h3>
                <h3 className="flex items-start sm:items-center text-lg sm:text-2xl gap-3">
                  <WebsiteIcon className="text-blue-700" />
                  <a
                    href="http://www.hill.af.mil/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-black underline hover:text-blue-600"
                  >
                    Hill AFB Official Website
                  </a>
                </h3>
              </div>

              {/* Embedded Map */}
              <div className="w-full lg:w-2/3 h-[300px] sm:h-[400px]">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d56681.686668837305!2d-111.99290458817843!3d41.133413783029326!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x875304fdb969a0f5%3A0x5b088d98c0f0e7d9!2s7981%20Georgia%20St%2C%20Hill%20AFB%2C%20UT%2084056%2C%20USA!5e0!3m2!1sen!2sin!4v1738316949671!5m2!1sen!2sin"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  className="rounded-md shadow-md"
                ></iframe>
              </div>
            </div>
          </div>
        </div>

        <div className="px-4 sm:px-6 lg:px-8 mb-12 max-w-[95%] mx-auto">
          <div className="w-full py-8 bg-gray-50 shadow-[0_4px_12px_0_rgba(1,76,178,0.3)] rounded-lg">
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-10 text-center text-blue-900 underline">
              Hill AFB Social Media Handles
            </h1>

            <div className="flex items-center justify-center">
              <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 px-4">
                {socialMediaPosts.map((post, index) => (
                  <div
                    key={index}
                    className="flex flex-col h-full max-h-[780px] border border-gray-200 rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-shadow"
                  >
                    {/* Social Media Embed Container */}
                    <div className="flex-grow min-h-[300px]">
                      <SocialMediaEmbed
                        platform={post.platform}
                        embed={post.embed}
                        className="h-full w-full"
                      />
                    </div>

                    {/* Footer with Link */}
                    <div className="bg-white p-4 border-t border-gray-200">
                      <a
                        href={post.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex flex-col items-center text-blue-600 hover:text-blue-800"
                      >
                        <span className="mb-2">Visit {post.platform}</span>
                        <img
                          src={post.icon}
                          className="h-8 w-auto"
                          alt={`${post.platform} icon`}
                        />
                      </a>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default Airforce;
